import { AbstractControl, Validators } from '@angular/forms';

export const DEFAULT_EXPENSE_FORM_GROUP = {
  id: [''],
  typeExpense: ['', Validators.required],
  dateExpense: ['', Validators.required],
  valueExpense: ['', Validators.required],
  currency: ['', Validators.required],
};

export type expenseFormControl = 'typeExpense' | 'dateExpense' | 'valueExpense' | 'currency' | 'id';

export const MinLengthArray = (min: number) => {
  return (c: AbstractControl): { MinLengthArray: boolean } | null => {
    if (c.value.length >= min) return null;

    return { MinLengthArray: true };
  };
};

export const MaxLengthArray = (max: number) => {
  return (c: AbstractControl): { MaxLengthArray: boolean } | null => {
    if (c.value.length <= max) return null;

    return { MaxLengthArray: true };
  };
};
